import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'
import useCloseButtonTop from '../../../hooks/useCloseButtonTop'
import { CurrentSubView, UIPart } from '../../../models/enums'
import { Dashboard as OldDashboard } from '../Common'
import Dashboard from '../../Menus/Large/Dashboard'
import DashboardButton from './DashboardButton'
import Remote from './Remote'

const RemoteContainer = ({ hideMenu = false }): JSX.Element => {
  const dispatch = useDispatch()
  const top = useCloseButtonTop()
  const menu = useSelector((state: RootState) => state.retorikReducer.configuration.menu)
  const dashboardOpened = useSelector((state: RootState) => state.utilsReducer.dashboardOpened)
  const isRTL = useSelector((state: RootState) => state.localeReducer.isRTL)

  /**
   * On call :
   *  - close subview if one is opened and if the parameter is false / undefined
   *  - toggle dashboardOpened state
   * @param doNotCloseViews : boolean
   */

  const toggleDashboard = (doNotCloseViews?: boolean): void => {
    !doNotCloseViews && dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.none))
    dispatch(storeActions.utils.setDashboardOpened(!dashboardOpened))
  }

  const handleClick = (e: React.MouseEvent): void => {
    dispatch(storeActions.utils.setClickedOnUI(UIPart.remote))
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <React.Fragment>
      <div
        className={`rf-absolute rf-z-[19] rf-hidden large:rf-flex rf-flex-col rf-items-center rf-justify-start rf-w-24 rf-right-0 ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-text-trueblack`}
        style={{
          top: top
        }}
        onClick={(e) => handleClick(e)}
      >
        {/* Dashboard button */}
        {!hideMenu && <DashboardButton dashboardVisible={false} onClick={(): void => toggleDashboard()} />}

        {/* Remote */}
        <Remote />
      </div>

      {/* Dashboard */}
      {dashboardOpened && (menu?.categories?.length ? <Dashboard toggleDashboard={(): void => toggleDashboard(true)} /> : <OldDashboard toggleDashboard={(): void => toggleDashboard(true)} />)}
    </React.Fragment>
  )
}

export default RemoteContainer
